import { CurationGrid } from '@/pages/curation/components/CurationGrid'
import { CurationSidebar } from '@/pages/curation/components/CurationSidebar'

export default function CurationBoardsPage() {
  return (
    <div className="flex flex-1 gap-6">
      <div className="flex-1 overflow-y-auto">
        <CurationGrid />
      </div>
      <CurationSidebar />
    </div>
  )
}
